import axios from 'axios';
import { useState } from 'react'
const API_URL = "https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod";
const URL = "https://43a8phnwnh.execute-api.us-east-1.amazonaws.com/prod";
export const getDatosUsuario = async (token) => {
    try {
        const response = await axios.post(`${URL}/datos-usuario`, {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ token, fk_idarea: 4704 }),
            isBase64Encoded: false,
        });
        const res = JSON.parse(response.data.body);
        return res;
    } catch (error) {
        console.log(error);
    }
};

export const getProvincias = async () => {
    try {
        const response = await fetch('https://api.depcsuite.com/td/getProvincias?id=12', {
            method: "get",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const res = await response.json();
        return res;
    } catch (error) {
        console.log(error);
    }
};

export const getLocalidades = async (fk_idprov) => {
    try {
        const response = await axios.post('https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/sce/conseguir-localidades', {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ fk_idprov }),
            isBase64Encoded: false,
        });
        const res = JSON.parse(response.data.body);
        return res;
    } catch (error) {
        console.log(error);
    }
};

const useUserData = () => {
  const [tipoDireccion, setTipoDireccion] = useState(false)
  const [localidades, setLocalidades] = useState([])
  const [localidadesFacturacion, setLocalidadesFacturacion] = useState([])
  const [esNuevo, setEsNuevo] = useState('')
  const [precioEnvioGratis, setPrecioEnvioGratis] = useState(1)
  const [precioEnvio, setPrecioEnvio] = useState(0)
  const [facturaA, setFacturaA] = useState(false)
  const [provincias, setProvincias] = useState([])
  const [envio, setEnvio] = useState(0);
  const [datosDomicilio, setDatosDomicilio] = useState({
    direccion: '',
    fk_idprov: '2',
    codpost: '',
    fk_idpais: 12,
    calle: '',
    nro: '',
    dpto: '',
    piso: '',
    numero_celular: '',
    calle: '',
    alias: '',
    entre_calles: '',
    alternativa: '',
    descripcion: '',
    email: '',
    retiro: '',
    cuit: '',
    fk_idtipodoc_persona: 7,
    documento_personal: '',
    nombre: '',
    apellido: '',
    fk_idlocalidad: '23055',
    razon_social: '',
    situacion: '1',
    direccion_facturacion: '',
    codpost_facturacion: '',
    fk_idprov_facturacion: '2',
    fk_idpais_facturacion: '12',
    dpto_facturacion: '',
    piso_facturacion: '',
    numero_celular_facturacion: '',
    calle_facturacion: '',
    alias_facturacion: '',
    nro_facturacion: '',
    entre_calles_facturacion: '',
    alternativa_facturacion: '',
    descripcion_facturacion: '',
    retiro_facturacion: '',
    fk_idtipodoc_persona_facturacion: '',
    fk_idlocalidad_facturacion: '23055',
    razon_social_facturacion: '',
    situacion_facturacion: '',
    tipoDireccion: true,
    nota: ''
  })

  const loadInitialData = async () => {
    const datosResponse = await getDatosUsuario(localStorage.getItem('token') || '')
    const tieneDatos = datosResponse.length > 0
    const datos = tieneDatos && datosResponse[0]

    setDatosDomicilio({
      iddomicilio: tieneDatos ? datos.iddomicilio : '',
      nombre: tieneDatos ? datos.nombre : '',
      cuit: tieneDatos ? datos.cuit : '',
      apellido: tieneDatos ? datos.apellido : '',
      email: tieneDatos ? datos.email : '',
      documento_personal: tieneDatos ? datos.documento_personal : '',
      direccion: tieneDatos ? datos.direccion : '',
      fk_idprov: datos.fk_idprov || 2,
      codpost: tieneDatos ? datos.codpost : '',
      fk_idpais: datos.fk_idpais || 12,
      dpto: tieneDatos ? datos.dpto : '',
      piso: tieneDatos ? datos.piso : '',
      numero_celular: tieneDatos ? datos.numero_celular : '',
      calle: tieneDatos ? datos.calle : '',
      nota: tieneDatos ? datos.nota : '',
      alias: tieneDatos ? datos.alias : '',
      entre_calles: tieneDatos ? datos.entre_calles : '',
      alternativa: tieneDatos ? datos.alternativa : '',
      descripcion: tieneDatos ? datos.observaciones : '',
      retiro: tieneDatos ? datos.retiro : '',
      nro: tieneDatos ? datos.nro : '',
      nro_facturacion: tieneDatos ? datos.nro_facturacion : '',
      calle_facturacion: tieneDatos ? datos.calle_facturacion : '',
      fk_idtipodoc_persona: tieneDatos ? datos.fk_idtipodoc_personal ? datos.fk_idtipodoc_personal : 7 : 7,
      fk_idlocalidad: datos.fk_idlocalidad,
      razon_social: tieneDatos
        ? datos.razon_social || `${datos.nombre} ${datos.apellido}`
        : undefined,
      situacion: tieneDatos ? datos.situacion ? datos.situacion : '1' : '1',
      direccion_facturacion: tieneDatos ? datos.direccion_facturacion : '',
      codpost_facturacion: tieneDatos ? datos.codpost_facturacion : '',
      fk_idprov_facturacion:
        datos.fk_idprov_facturacion ||
        (tieneDatos ? datos.fk_idprov_facturacion : ''),
      fk_idpais_facturacion: tieneDatos ? datos.fk_idpais_facturacion : '',
      dpto_facturacion: tieneDatos ? datos.dpto_facturacion : '',
      piso_facturacion: tieneDatos ? datos.piso_facturacion : '',
      numero_celular_facturacion: tieneDatos
        ? datos.numero_celular_facturacion
        : '',
      calle_facturacion: tieneDatos ? datos.calle_facturacion : '',
      alias_facturacion: tieneDatos ? datos.alias_facturacion : '',
      entre_calles_facturacion: tieneDatos
        ? datos.entre_calles_facturacion
        : '',
      alternativa_facturacion: tieneDatos ? datos.alternativa_facturacion : '',
      descripcion_facturacion: tieneDatos ? datos.descripcion_facturacion : '',
      retiro_facturacion: tieneDatos ? datos.retiro_facturacion : '',
      fk_idtipodoc_persona_facturacion: tieneDatos
        ? datos.fk_idtipodoc_persona_facturacion
        : '',
      fk_idlocalidad_facturacion:
        datos.fk_idlocalidad_facturacion ||
        (tieneDatos ? datos.fk_idlocalidad_facturacion : ''),
      razon_social_facturacion: tieneDatos
        ? datos.razon_social_facturacion
        : '',
      situacion_facturacion: tieneDatos ? datos.situacion_facturacion : 1,
      tipoDireccion: tieneDatos ? true : false
    })

    setEsNuevo(tieneDatos ? datos.iddomicilio : '')

    const provinciasData = await getProvincias()
    setProvincias(provinciasData)

    const fk = tieneDatos ? datos.fk_idprov || 2 : 2
    const locs = await getLocalidades(fk)
    setLocalidades(locs)
    setLocalidadesFacturacion(locs)
  }

  return {
    datosDomicilio,
    setDatosDomicilio,
    loadInitialData,
    tipoDireccion,
    setTipoDireccion,
    localidades,
    setLocalidades,
    esNuevo,
    setEsNuevo,
    precioEnvioGratis,
    setPrecioEnvioGratis,
    precioEnvio,
    setPrecioEnvio,
    facturaA,
    setFacturaA,
    provincias,
    setProvincias,
    localidadesFacturacion,
    setLocalidadesFacturacion,
    envio, 
    setEnvio
  }
}

export default useUserData